import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./header.css";
import { FiMenu, FiX, FiChevronDown } from "react-icons/fi";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [solutionOpen, setSolutionOpen] = useState(false);

  return (
    <header className="startup-header mb-5">

      <motion.div 
        className="header-inner container-fluid"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >

        {/* LOGO */}
        <Link to="/" className="header-logo">
          <img src="./images/startup-logo.png" alt="logo" />
        </Link>

        {/* DESKTOP MENU */}
        <nav className="desktop-menu">
          <Link to="/blog">Blogs</Link>
          <Link to="/pricing">Pricing</Link>
          <Link to="/about">About Us</Link>
          <Link to="/contact">Contact Us</Link>

          {/* SOLUTION DROPDOWN */}
          <div
            className="solution-dropdown"
            onMouseEnter={() => setSolutionOpen(true)}
            onMouseLeave={() => setSolutionOpen(false)}
          >
            <span className="dropdown-title">
              Solution <FiChevronDown size={16} />
            </span>

            <motion.div
              className={`dropdown-box ${solutionOpen ? "show" : ""}`}
              initial={{ opacity: 0, y: 10 }}
              animate={solutionOpen ? { opacity: 1, y: 0 } : { opacity: 0, y: 10 }}
            >
              <Link to="/flow">Deal Flow</Link>
              <Link to="/demo">Demo Day</Link>
            </motion.div>
          </div>

          <Link to="/login" className="login-btn">Login</Link>
        </nav>

        {/* MOBILE TOGGLE */}
        <button 
          className="mobile-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
        </button>
      </motion.div>

      {/* MOBILE MENU */}
      <motion.div 
        className={`mobile-menu ${menuOpen ? "open" : ""}`}
        initial={{ height: 0 }}
        animate={{ height: menuOpen ? "auto" : 0 }}
      >
        <Link to="/blogs" onClick={() => setMenuOpen(false)}>Blogs</Link>
        <Link to="/pricing" onClick={() => setMenuOpen(false)}>Pricing</Link>
        <Link to="/about" onClick={() => setMenuOpen(false)}>About Us</Link>
        <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact Us</Link>

        {/* MOBILE DROPDOWN */}
        <div className="mobile-dropdown">
          <button 
            onClick={() => setSolutionOpen(!solutionOpen)}
            className="dropdown-btn"
          >
            Solution <FiChevronDown />
          </button>

          {solutionOpen && (
            <motion.div 
              className="mobile-submenu"
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <Link to="/flow">Deal Flow</Link>
              <Link to="/demo">Demo Day</Link>
            </motion.div>
          )}
        </div>

        <Link to="/login" className="login-btn mobile-login">Login</Link>
      </motion.div>
    </header>
  );
};

export default Header;
